export default __webpack_public_path__ + "static/media/icon-horario.ad0f2c5f.svg";